
import { Mixins, Component, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
@Component({
    inheritAttrs: false,
})
export default class SelectLanguage extends Mixins<MixinInterface>() {
    @VModel() language!: string

    get items() {
        return this.languagesAvailableForUsers
    }
}
